import moment from 'moment';

export const handleDescription = (description) => {
	if (description.length > 0) {
		return moment(description[0].date_process).format('DD/MM/YYYY HH:mm:ss');
	}
	return '-';
};
